<div class="header">
  <div class="action">
    <div class="close" (click)="close()">
      <mat-icon svgIcon="cross"></mat-icon>
    </div>
  </div>
</div>

<div class="modal-header">
  <h3 class="modal-title">{{ 'photo-capture-modal.title' | translate }}</h3>
</div>

<div class="modal-body">
  <cpf-camera-photo #cameraComponent [maxSizeBytes]="maxSizeBytes"></cpf-camera-photo>
</div>

@if (error) {
  <div class="pdf-error">
    <mat-icon>error</mat-icon>
    <p>{{ error }}</p>
  </div>
}

<div class="modal-footer">
  <button (click)="cancel()" class="button secondary" [disabled]="isGeneratingPdf">
    {{ 'general-confirmation-modal.modal-footer.cancel-button' | translate }}
  </button>

  <button (click)="confirm()"
    class="button primary"
    [disabled]="!hasPhotos || isGeneratingPdf || isOverSizeBudget">
    {{ (isGeneratingPdf ? 'photo-capture-modal.buttons.generating' : 'photo-capture-modal.buttons.generate-pdf') | translate }}
  </button>
</div>
